import { Option } from '../dropDownInput/dropDownInput.type';

export const genderOptions: Option[] = [
  { label: 'createInterventionReport.genderOptions.male', value: 'Male' },
  { label: 'createInterventionReport.genderOptions.female', value: 'Female' },
  { label: 'createInterventionReport.genderOptions.other', value: 'Other' },
];

export const ageOptions: Option[] = [
  { label: 'createInterventionReport.ageOptions.20-30', value: '20-30' },
  { label: 'createInterventionReport.ageOptions.30-40', value: '30-40' },
  { label: 'createInterventionReport.ageOptions.40-50', value: '40-50' },
  { label: 'createInterventionReport.ageOptions.50-60', value: '50-60' },
  { label: 'createInterventionReport.ageOptions.60+', value: '60+' },
];

export enum Ethnicity {
  PAKEHA = 'Pākehā - European New Zealanders',
  MAORI = 'Māori',
  PASIFIKA = 'Pasifika',
  ASIAN = 'Asian',
  MELAA = 'MELAA',
  OTHER = 'Other',
}

export const ethinicityOptions: Option[] = [
  { label: Ethnicity.PAKEHA, value: Ethnicity.PAKEHA },
  { label: Ethnicity.MAORI, value: Ethnicity.MAORI },
  { label: Ethnicity.PASIFIKA, value: Ethnicity.PASIFIKA },
  { label: Ethnicity.ASIAN, value: Ethnicity.ASIAN },
  { label: Ethnicity.MELAA, value: Ethnicity.MELAA },
  { label: Ethnicity.OTHER, value: Ethnicity.OTHER },
];

export const lengthOfPlayOptions: Option[] = [
  {
    label: 'createInterventionReport.lengthOfPlayOptions.gambleTime',
    value: 'createInterventionReport.lengthOfPlayOptions.gambleTime',
  },
  {
    label: 'createInterventionReport.lengthOfPlayOptions.consecutiveSweeps',
    value: 'createInterventionReport.lengthOfPlayOptions.consecutiveSweeps',
  },
  {
    label: 'createInterventionReport.lengthOfPlayOptions.gambleDays',
    value: 'createInterventionReport.lengthOfPlayOptions.gambleDays',
  },
  {
    label: 'createInterventionReport.lengthOfPlayOptions.closingTime',
    value: 'createInterventionReport.lengthOfPlayOptions.closingTime',
  },
  {
    label: 'createInterventionReport.lengthOfPlayOptions.openingTime',
    value: 'createInterventionReport.lengthOfPlayOptions.openingTime',
  },
  {
    label: 'createInterventionReport.lengthOfPlayOptions.openingToClosing',
    value: 'createInterventionReport.lengthOfPlayOptions.openingToClosing',
  },
];

export const moneyOptions: Option[] = [
  {
    label: 'createInterventionReport.moneyOptions.largeWinsBack',
    value: 'createInterventionReport.moneyOptions.largeWinsBack',
  },
  {
    label: 'createInterventionReport.moneyOptions.ATMWithdraw',
    value: 'createInterventionReport.moneyOptions.ATMWithdraw',
  },
  {
    label: 'createInterventionReport.moneyOptions.ATMDeclined',
    value: 'createInterventionReport.moneyOptions.ATMDeclined',
  },
  {
    label: 'createInterventionReport.moneyOptions.findMoreMoney',
    value: 'createInterventionReport.moneyOptions.findMoreMoney',
  },
  {
    label: 'createInterventionReport.moneyOptions.borrowMoney',
    value: 'createInterventionReport.moneyOptions.borrowMoney',
  },
];

export const behaviourOptions: Option[] = [
  {
    label: 'createInterventionReport.behaviourOptions.angryAtPlayers',
    value: 'createInterventionReport.behaviourOptions.angryAtPlayers',
  },
  {
    label: 'createInterventionReport.behaviourOptions.rude',
    value: 'createInterventionReport.behaviourOptions.rude',
  },
  {
    label: 'createInterventionReport.behaviourOptions.complains',
    value: 'createInterventionReport.behaviourOptions.complains',
  },
  {
    label: 'createInterventionReport.behaviourOptions.twoMachines',
    value: 'createInterventionReport.behaviourOptions.twoMachines',
  },
  {
    label: 'createInterventionReport.behaviourOptions.intense',
    value: 'createInterventionReport.behaviourOptions.intense',
  },
  {
    label: 'createInterventionReport.behaviourOptions.fastPlay',
    value: 'createInterventionReport.behaviourOptions.fastPlay',
  },
  {
    label: 'createInterventionReport.behaviourOptions.rituals',
    value: 'createInterventionReport.behaviourOptions.rituals',
  },
  {
    label: 'createInterventionReport.behaviourOptions.problems',
    value: 'createInterventionReport.behaviourOptions.problems',
  },
  {
    label: 'createInterventionReport.behaviourOptions.frustration',
    value: 'createInterventionReport.behaviourOptions.frustration',
  },
  {
    label: 'createInterventionReport.behaviourOptions.signsDistress',
    value: 'createInterventionReport.behaviourOptions.signsDistress',
  },
  {
    label: 'createInterventionReport.behaviourOptions.obviousDistress',
    value: 'createInterventionReport.behaviourOptions.obviousDistress',
  },
  {
    label: 'createInterventionReport.behaviourOptions.angryAtStaff',
    value: 'createInterventionReport.behaviourOptions.angryAtStaff',
  },
  {
    label: 'createInterventionReport.behaviourOptions.avoidBeingSeen',
    value: 'createInterventionReport.behaviourOptions.avoidBeingSeen',
  },
];

export const otherOptions: Option[] = [
  {
    label: 'createInterventionReport.otherOptions.hygiene',
    value: 'createInterventionReport.otherOptions.hygiene',
  },
  {
    label: 'createInterventionReport.otherOptions.childrenUnattended',
    value: 'createInterventionReport.otherOptions.childrenUnattended',
  },
  {
    label: 'createInterventionReport.otherOptions.familyConcerns',
    value: 'createInterventionReport.otherOptions.familyConcerns',
  },
  {
    label: 'createInterventionReport.otherOptions.exclusion',
    value: 'createInterventionReport.otherOptions.exclusion',
  },
];

export const actionTakenOptions: Option[] = [
  {
    label: 'createInterventionReport.actionTakenOptions.askedPlayer',
    value: 'createInterventionReport.actionTakenOptions.askedPlayer',
  },
  {
    label: 'createInterventionReport.actionTakenOptions.approachedPlayer',
    value: 'createInterventionReport.actionTakenOptions.approachedPlayer',
  },
  {
    label: 'createInterventionReport.actionTakenOptions.interview',
    value: 'createInterventionReport.actionTakenOptions.interview',
  },
  {
    label: 'createInterventionReport.actionTakenOptions.quietArea',
    value: 'createInterventionReport.actionTakenOptions.quietArea',
  },
  {
    label: 'createInterventionReport.actionTakenOptions.escalate',
    value: 'createInterventionReport.actionTakenOptions.escalate',
  },
  {
    label: 'createInterventionReport.actionTakenOptions.other',
    value: 'createInterventionReport.actionTakenOptions.other',
  },
];

export enum FollowUpActions {
  NO_ACTION = 'noAction',
  MONITOR_BEHAVIOUR = 'monitorBehaviour',
  APPROACH_PLAYER = 'approachPlayer',
  PROVIDE_INFORMATION = 'provideInformation',
  EXCLUDE = 'exclude',
  ISSUE_EXCLUSION = 'issueExclusion',
  OTHER = 'other',
}

export const followUpOptions: Option[] = [
  {
    label: 'createInterventionReport.followUpOptions.noAction',
    value: 'createInterventionReport.followUpOptions.noAction',
  },
  {
    label: 'createInterventionReport.followUpOptions.monitorBehaviour',
    value: 'createInterventionReport.followUpOptions.monitorBehaviour',
  },
  {
    label: 'createInterventionReport.followUpOptions.approachPlayer',
    value: 'createInterventionReport.followUpOptions.approachPlayer',
  },
  {
    label: 'createInterventionReport.followUpOptions.provideInformation',
    value: 'createInterventionReport.followUpOptions.provideInformation',
  },
  {
    label: 'createInterventionReport.followUpOptions.exclude',
    value: 'createInterventionReport.followUpOptions.exclude',
  },
  {
    label: 'createInterventionReport.followUpOptions.issueExclusion',
    value: 'createInterventionReport.followUpOptions.issueExclusion',
  },
  {
    label: 'createInterventionReport.followUpOptions.other',
    value: 'createInterventionReport.followUpOptions.other',
  },
];

export const ethnicityTooltipContents: {
  title: string;
  points: string[];
}[] = [
  {
    title: 'Pākehā (European New Zealanders):',
    points: [
      'createInterventionReport.tooltipContent.Pākehā.point1',
      'createInterventionReport.tooltipContent.Pākehā.point2',
    ],
  },
  {
    title: 'Māori:',
    points: ['createInterventionReport.tooltipContent.Māori.point1'],
  },
  {
    title: 'Pasifika:',
    points: [
      'createInterventionReport.tooltipContent.Pasifika.point1',
      'createInterventionReport.tooltipContent.Pasifika.point2',
    ],
  },
  {
    title: 'Asian:',
    points: ['createInterventionReport.tooltipContent.Asian.point1'],
  },
  {
    title: 'MELAA:',
    points: ['createInterventionReport.tooltipContent.Melaa.point1'],
  },
  {
    title: 'Other:',
    points: ['createInterventionReport.tooltipContent.Other.point1'],
  },
];
